export {default} from './ClientReportPopover.connect';
